import React from "react";
import { Router } from "@abyss/web/ui/Router";

export const Home = () => {
  return (
    <React.Fragment>
      <style>
        {`
        /* prototype structure code */
.protoWrap {
  max-width: 805px;
  width: 100%;
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 30px;
  margin-top: 60px;
  margin-bottom: 60px;
}

/* recommendation card */
.card {
  position: relative;
  display: flex;
}

.card-flair {
  position: absolute;
  height: 4rem;
  top: 0;
  left: 0;
  width: 100%;
  background-color: #002677;
  border-top-right-radius: 36px;
  border-top-left-radius: 36px;
}

.card-inner {
  position: relative;
  display: flex;
  flex-direction: column;
  width: 100%;
  background: #fff;
  border-radius: 16px;
  box-shadow: 0 6px 12px 0 rgba(0, 0, 0, .15);
  margin-top: 1rem;
}

.card-hd {
  padding: 1rem;
}

.card-bd {
  flex: 1;
  padding: 1rem;
  background-color: #EEF8FB;
}

.card-ft {
  display: flex;
  align-items: center;
  padding: 1rem;
}

.flag {
  position: relative;
  margin-left: -1.75rem;
}

.flag-bar {
  clip-path: polygon(0px 0px, 100% 0px, calc(100% - 15px) 100%, 0% 100%);
  background-color: #d14600;
  padding-block: 0.5rem;
  padding-inline: 1.25rem;
  border-bottom-left-radius: 0.375rem;
  border-top-left-radius: 0.375rem;
  color: #fff;
  font-size: 16px;
  font-weight: 700;
}

.flag:before {
  content: '';
  width: 16px;
  height: 48px;
  background-image: url(./assets/images/flag.svg);
  background-position: top left;
  background-repeat: no-repeat;
  display: block;
  position: absolute;
  top: 0;
  left: 0;
  z-index: 5;
}

.card-title {
  margin-top: 13px;
}

.card-title a {
  color: #002677;
  font-family: "UHC2020 Sans";
  font-size: 20px;
  font-style: normal;
  font-weight: 700;
  text-decoration-line: underline;
  text-decoration-style: solid;
  line-height: 1.2;
}

.card-info {
  display: flex;
  gap: 48px;
  margin-bottom: 16px;
}

.card-data {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.card-data-hd {
  color: #4B4D4F;
  font-family: "UHC2020 Sans";
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 1.07;
}

.card-data-bd {
  color: #002677;
  font-family: "UHC Serif Headline";
  font-size: 30px;
  font-style: normal;
  font-weight: 600;
  line-height: 1.06;
}

.card-button button {
  display: inline-flex;
  background: #d14600;
  border: 1px solid #d14600;
  height: 40px;
  padding: 0 20px;
  max-width: 168px;
  width: 100%;
  align-items: center;
  appearance: none;
  border-radius: 1.5rem;
  color: #fff;
  cursor: pointer;
  font-size: 16px;
  font-weight: 700;
  justify-content: center;
  line-height: 20px;
  position: relative;
  transition-duration: .25s;
  transition-property: background;
  transition-timing-function: cubic-bezier(.2,.8,.4,1);
  white-space: nowrap;
}

.card-button button:hover {
  background: #aa3600;
}

.card-ft button {
  display: inline-flex;
  align-items: center;
  color: #196ecf;
  text-decoration: none;
  font-weight: 700;
  font-size: 16px;
  appearance: none;
  border: 0;
  background: transparent;
}

.card-ft button:hover {
  text-decoration: underline;
}

/* CTA Card */
.cta-card {
  width: 100%;
  border-radius: 24px;
  border: 1px solid #CBCCCD;
  background: #F7FCFD;
  padding: 26px 20px;
}

.cta-card-hd {
  margin-bottom: 20px;
}

.cta-title {
  color: #002677;
  font-family: "UHC Serif Headline";
  font-size: 24px;
  font-style: normal;
  font-weight: 600;
  line-height: 1.3;
  margin-bottom: 16px;
}

.cta-card-ft {
  margin-top: 24px;
}

.alt-button {
  display: flex;
  height: 40px;
  padding: 8px 16px;
  justify-content: center;
  align-items: center;
  gap: 8px;
  border-radius: 24px;
  border: 1px solid #002677;
  background: #fff;
  color: #002677;
  text-align: center;
  font-family: "UHC2020 Sans";
  font-size: 16px;
  font-style: normal;
  font-weight: 700;
}
  
.logos {
margin: 60px auto;
max-width: 400px;
}

.logos > * + * {
margin-top: 40px;}
`}
      </style>
      <Router.MetaTags title="Home" />
    </React.Fragment>
  );
};
